import moment from 'moment';
import {
  START_TRIP_SEARCH,
  SET_TRIP_SEARCH_RESULTS,
  TRIP_SEARCH_FAILED,
  SET_SEARCH_INPUT,
  SET_TRIP_SUMMARY,
  SET_TRAVEL_CART,
  SET_GEOLOCATION,
  UPDATE_PASSENGER_DETAILS,
  UPDATE_REPORTING_FIELDS,
  ADD_TRIP_NAME,
  SET_LOW_FARES,
  UPDATE_AIR_FARE,
  SET_CHANGERES,
  UPDATE_PASSENGER_DETAILS_REBOOK,
  SET_SEATS_FOR_REBOOK_PASSENGERS,
  FRONTIER_FLIGHT_REIMBURSMENT_UPDATE,
  UPDATE_SELECTED_AWARD,
  SET_LOCATION_DETAIL,
  HOMEPAGE_ONEWAY_UDID_DATA,
} from '../actions/search';
import {
  SELECT_AIR,
  UPDATE_TRIP_SEARCH_RESULTS,
  UPDATE_SEARCH_INPUT_DATES,
  SET_CAR_PICKUP_DROPOFF_DATE,
  SET_CAR_REQUEST_COMPONENT_ID,
} from '../actions/air';
import { SELECT_CAR } from '../actions/car';
import { SELECT_HOTEL_DETAIL } from '../actions/hotel';
import { SELECT_RAIL } from '../actions/rail';
import { SET_REPRICED_AIR_RESULTS, SET_REPRICED_AIR_ERROR } from '../actions/payment';
import { MOVE_NEXT, MOVE_PREVIOUS_HOTEL_DETAIL } from '../actions/workflow';
import { customFieldDataTypes, customUDIDEntryTypes } from '../../constants/Enums';

const initialState = {
  searchInput: null, // this is what the user has entered from the tripSearchWidget(air, hotel, car, rail)
  lowFares: null,
  geolocation: null,
  tripResults: null, // response from trip/search that contains travelRequestId and RequestedComponent Flow
  tripResultsLoading: false,
  activeRequestedComponentIndex: 0,
  tripSummary: null, // contains the summarized info of selected flight/car/hotels
  travelCart: null, // contains passenger info, plus more detailed summary of cart after selection is complete and booking flow actually starts
};

const getFormattedReportingFields = (actionObject, deploymentMap, IsPerPassenger) => {
  const { ReportingFields, customFields } = actionObject;
  // Filtering by UDIDs displayed in the screen
  return ReportingFields?.filter((field) => {
    const { UDIDText } = field;
    return deploymentMap[UDIDText];
  })?.map((field) => {
    const { UDIDEntryType, TextEntry, UDIDText, ReportingGroupOptions } = field;
    const { TEXT_ENTRY, PULL_DOWN, PULL_DOWN_WITH_CONDITIONAL_QUESTIONS } = customUDIDEntryTypes;
    const { DATE_TIME } = customFieldDataTypes;
    const Value = customFields?.[UDIDText];
    switch (UDIDEntryType) {
      case TEXT_ENTRY:
        //The value is being formatted if the data type is date
        if (TextEntry === DATE_TIME) {
          const date = moment(Value);
          return {
            ...field,
            Value: date.isValid() ? date.format('MM/DD/YYYY') : '',
            // Adding IsPerPassenger to know where the input was filled
            IsPerPassenger,
          };
        }
        // Other cases | Adding IsPerPassenger to know where the input was filled
        return { ...field, Value: Value ? Value : '', IsPerPassenger };
      case PULL_DOWN_WITH_CONDITIONAL_QUESTIONS:
      case PULL_DOWN: {
        const CompanyUDIDOptionID = parseInt(Value);
        const CompanyUDIDOptionCode = ReportingGroupOptions.find(
          (option) => option.CompanyUDIDOptionsKey === CompanyUDIDOptionID
        )?.UdidOptionCode;
        return {
          ...field,
          CompanyUDIDOptionID: CompanyUDIDOptionID ? CompanyUDIDOptionID : 0,
          Value: CompanyUDIDOptionCode || '',
          // adding IsPerPassenger to know where the input was filled
          IsPerPassenger,
        };
      }
      default:
        return null;
    }
  });
};

const buildAndSetLoyaltyList = (updatedList, originalList, filterKey) => {
  //To remove loyalty which user didn't fill
  updatedList = updatedList?.filter(function (obj) {
    return obj.ProgramNumber !== '';
  });
  if (updatedList !== undefined && updatedList?.length > 0) {
    const mergedArray = [...updatedList, ...originalList];
    const seen = new Set();
    // to remove the old duplicate loyalty
    const result = mergedArray?.filter((obj) => {
      if (seen?.has(obj[filterKey])) {
        return false;
      } else {
        seen?.add(obj[filterKey]);
        return true;
      }
    });
    return result;
  } else {
    return originalList;
  }
};
export default (state = initialState, action) => {
  switch (action.type) {
    case START_TRIP_SEARCH: {
      return {
        ...state,
        tripName: '',
        tripResultsLoading: true,
        activeRequestedComponentIndex: 0,
      };
    }
    case SET_GEOLOCATION: {
      return {
        ...state,
        geolocation: {
          latitude: action.latitude,
          longitude: action.longitude,
          airportCode: action.airportCode,
        },
      };
    }
    case SET_LOCATION_DETAIL: {
      return {
        ...state,
        locationDetail: action.addressObj,
      };
    }
    case SET_LOW_FARES: {
      return {
        ...state,
        lowFares: action.lowFares,
      };
    }
    case SET_TRIP_SEARCH_RESULTS:
      return {
        ...state,
        tripResults: action.tripResults,
        tripResultsLoading: false,
      };
    case UPDATE_TRIP_SEARCH_RESULTS:
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          SelectedAward: action.tripResults.SelectedAward,
          TravelRequestId: action.tripResults.TravelRequestId,
          RequestedComponents: state.tripResults.RequestedComponents.map((component) => {
            return { ...component, ComponentRequestId: action.tripResults.airRequestId };
          }),
        },
        tripResultsLoading: false,
      };
    case SET_CAR_PICKUP_DROPOFF_DATE:
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          RequestedComponents: state.tripResults.RequestedComponents.map((component) => {
            if (component.ComponentName === action.componentType) {
              if (action.legNumber === 1) {
                return { ...component, pickupDate: action.pickupDate };
              } else {
                return { ...component, dropoffDate: action.dropoffDate };
              }
            }
            return component;
          }),
        },
      };
    case SET_CAR_REQUEST_COMPONENT_ID:
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          RequestedComponents: state.tripResults.RequestedComponents.map((component) => {
            if (component.ComponentName === action.componentType) {
              return { ...component, ComponentRequestId: action.carComponentId };
            }
            return component;
          }),
        },
      };
    case TRIP_SEARCH_FAILED: {
      return {
        ...state,
        tripResultsLoading: false,
      };
    }
    case SET_CHANGERES:
      return {
        ...state,
        changeResTrip: action.changeResData,
      };
    case SET_SEARCH_INPUT:
      if (action.searchInput.IschangeRes) {
        return { ...state, searchInput: action.searchInput };
      } else {
        if (state.changeResTrip) {
          const res = Object.assign({}, state);
          delete res['changeResTrip'];
          return res;
        }
        return { ...state, searchInput: action.searchInput };
      }
    case UPDATE_SEARCH_INPUT_DATES:
      return {
        ...state,
        searchInput: {
          ...state.searchInput,
          searchCriteria: [
            {
              ...state.searchInput.searchCriteria[0],
              fromDate: action.selectedDates.departDate,
              toDate: action.selectedDates.arrivalDate,
            },
          ],
        },
      };
    case MOVE_NEXT: {
      return {
        ...state,
        activeRequestedComponentIndex: action.nextStep.DisplayIndex,
        searchOriginScreen: action.searchOriginScreen
          ? action.searchOriginScreen
          : state.searchOriginScreen,
      };
    }
    case MOVE_PREVIOUS_HOTEL_DETAIL: {
      return {
        ...state,
        activeRequestedComponentIndex: state.activeRequestedComponentIndex - 1,
      };
    }
    case SELECT_AIR: {
      const { selectedAir, brand = {} } = action;
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          RequestedComponents: state.tripResults.RequestedComponents.map((x) => {
            if (
              x.ComponentName === 'air' &&
              (x.LegNumber === selectedAir.LegNumber ||
                x.LegNumber === selectedAir?.legs?.[0].legNumber)
            ) {
              return {
                ...x,
                IsDisplayed: true,
                ResponseId: !action.isAirCloud
                  ? action.newMultiBrandResponseKey
                    ? action.newMultiBrandResponseKey
                    : selectedAir.ResponseID
                  : '00000000-0000-0000-0000-000000000000',
                MultiBrandKey: !action.isAirCloud
                  ? brand.MultiBrandID
                  : '00000000-0000-0000-0000-000000000000',
                PolicyException: brand.ReasonCode ? brand.ReasonCode : brand.reasonCode,
                LowestFare: action.lowestFare,
              };
            }
            return x;
          }),
        },
      };
    }
    case SELECT_HOTEL_DETAIL: {
      const selectedHotelDetail = action.selectedHotelDetail;
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          RequestedComponents: state.tripResults.RequestedComponents.map((x) => {
            if (x.DisplayIndex === action.displayIndex) {
              return {
                ...x,
                IsDisplayed: true,
                ResponseId: selectedHotelDetail.ResponseID,
                ResponseDetailId: selectedHotelDetail.GUID,
                PolicyKey: selectedHotelDetail.OutSidePolicyException?.PolicyKey,
                PolicyException: selectedHotelDetail.OutSidePolicyException?.ReasonDescription,
                ImageUrl: selectedHotelDetail.ImageUrl,
                LowestFare: action.lowestPrice,
              };
            }
            return x;
          }),
        },
      };
    }
    case SELECT_CAR: {
      const selectedCar = action.selectedCar;
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          RequestedComponents: state.tripResults.RequestedComponents.map((x) => {
            if (x.DisplayIndex === action.displayIndex) {
              return {
                ...x,
                IsDisplayed: true,
                ResponseDetailId: selectedCar.ResponseDetailKey,
                LowestFare: action.lowestFare,
                PolicyKey: selectedCar.OutSidePolicyException?.PolicyKey,
                PolicyException: selectedCar.OutSidePolicyException?.ReasonDescription,
              };
            }
            return x;
          }),
        },
      };
    }
    case SELECT_RAIL: {
      const { selectedRail, classFare } = action;
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          RequestedComponents: state.tripResults.RequestedComponents.map((x) => {
            if (x.DisplayIndex === action.displayIndex) {
              return {
                ...x,
                IsDisplayed: true,
                LowestFare: 0,
                MultiBrandKey: '00000000-0000-0000-0000-000000000000',
                ResponseId: '00000000-0000-0000-0000-000000000000',
                ResponseDetailId: '00000000-0000-0000-0000-000000000000',
                SelectedClassFareId: classFare.offerId,
                RailJson: {
                  ...selectedRail,
                  ID: '00000000-0000-0000-0000-000000000000',
                  Id: '00000000-0000-0000-0000-000000000000',
                },
              };
            }
            return x;
          }),
        },
      };
    }
    case UPDATE_PASSENGER_DETAILS_REBOOK:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          Passengers: state?.travelCart?.Passengers?.map((passenger, index) => {
            return {
              ...passenger,
              Title: action.passengers?.passengers[index]?.title || '',
              FirstName: action.passengers?.passengers[index]?.firstname || '',
              BirthDate: action.passengers?.passengers[index]?.birthdate || '',
              EmailAddress: action.passengers?.passengers[index]?.email || '',
              Gender: action.passengers?.passengers[index]?.gender || '',
              LastName: action.passengers?.passengers[index]?.lastname || '',
              MiddleName: action.passengers?.passengers[index]?.middlename || '',
              Phone: action.passengers?.passengers[index]?.phone || 0,
              RedressNumber: action.passengers?.passengers[index]?.redressNumber || '',
              KnownTravellerNumber:
                action.passengers?.passengers[index]?.knownTravellerNumber || '',
              KnownTravellerNumberCountryCode:
                action.passengers?.passengers[index]?.knownTravellerNumberCountryCode || '',
              PhoneCountryCode: action.passengers.passengers[index].phoneCountryCode || '',
              AssociateTravelerRefNumber:
                parseFloat(action.passengers?.passengers[index]?.associateTravelerRefNumber) || 0,
            };
          }),
          FrequentFlyers: action.passengers?.loyalty.airLoyalty || [],
          HotelLoyaltys: action.passengers?.loyalty.hotelLoyalty || [],
          CarLoyaltys: action.passengers?.loyalty.carLoyalty || [],
          RailLoyaltys: action.passengers?.loyalty.railLoyalty || [],
          IncludePriceInEmail: action.passengers?.IncludePriceInEmail || false,
        },
      };
    case SET_SEATS_FOR_REBOOK_PASSENGERS:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          Passengers: state?.travelCart?.Passengers?.map((passenger, index) => {
            const passengerNameKey = passenger?.FirstName + '_' + passenger?.LastName;
            return {
              ...passenger,
              SelectedSeatNumber: action?.seats[passengerNameKey]?.SeatNumber || '',
            };
          }),
        },
      };
    case UPDATE_PASSENGER_DETAILS:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          Passengers: state.travelCart.Passengers.map((passenger, index) => {
            return {
              ...passenger,
              FirstName: action.passengers.passengers[index].firstname.trim(),
              BirthDate: action.passengers.passengers[index].birthdate,
              EmailAddress: action.passengers.passengers[index].email.trim(),
              Gender: action.passengers.passengers[index].gender,
              LastName: action.passengers.passengers[index].lastname.trim(),
              MiddleName: action.passengers.passengers[index].middlename,
              Phone: action.passengers.passengers[index].phone.trim(),
              RedressNumber: action.passengers.passengers[index].redressNumber?.trim(),
              KnownTravellerNumber: action.passengers.passengers[
                index
              ].knownTravellerNumber?.trim(),
              KnownTravellerNumberCountryCode:
                action.passengers.passengers[index].knownTravellerNumberCountryCode,
              AssociateTravelerRefNumber:
                parseFloat(action.passengers?.passengers[index]?.associateTravelerRefNumber) || 0,
              PhoneCountryCode: action.passengers.passengers[index].phoneCountryCode,
              IsExcludePricingInfo: action.passengers?.passengers[index]?.IsExcludePricingInfo,
              FrequentFlyers: buildAndSetLoyaltyList(
                action.passengers.passengers[index].FrequentFlyers,
                action.passengers.loyalty?.airLoyalty,
                'AirLineCode'
              ),
              CarLoyalty: buildAndSetLoyaltyList(
                action.passengers.passengers[index].CarLoyalty,
                action.passengers.loyalty?.carLoyalty,
                'CarVendorCode'
              ),
              HotelLoyalty: buildAndSetLoyaltyList(
                action.passengers.passengers[index].HotelLoyalty,
                action.passengers.loyalty?.hotelLoyalty,
                'HotelChainCode'
              ),
              PassportDetails: action.passengers.passengers[index].PassportDetails?.map(
                (passport, i) => {
                  return {
                    PassportCountryCode:
                      action.passengers.passengers[index].PassportDetails[i].passportCountryCode,
                    PassportDate:
                      action.passengers.passengers[index].PassportDetails[i].passportDate,
                    PassportNumber:
                      action.passengers.passengers[index].PassportDetails[i].passportNumber,
                  };
                }
              ),
              ReportingFields: getFormattedReportingFields(
                action.passengers.passengers[index],
                action?.deploymentMap,
                true
              ),
            };
          }),
          RailLoyaltys: action.passengers.loyalty.railLoyalty,
          IncludePriceInEmail: action.passengers.IncludePriceInEmail,
        },
      };
    case UPDATE_REPORTING_FIELDS:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          ReportingFields: getFormattedReportingFields(
            action?.passengers,
            action?.deploymentMap,
            false
          ),
        },
      };
    case SET_TRIP_SUMMARY:
      return {
        ...state,
        tripSummary: action.tripSummary,
      };
    case SET_TRAVEL_CART:
      return {
        ...state,
        travelCart: action.travelCart,
      };
    case UPDATE_AIR_FARE:
      return {
        ...state,
        tripSummary: {
          ...state.tripResults,
          ...state.tripSummary,
          AirResponses: state?.tripSummary?.AirResponses?.map((airResponse) => {
            return {
              ...airResponse,
              TotalFare: action.totalFare,
            };
          }),
        },
      };
    case ADD_TRIP_NAME:
      return {
        ...state,
        tripName: action.tripName,
      };
    case SET_REPRICED_AIR_RESULTS:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          RepricedAirCost: action.reprice.RepricedAirCost,
          IsSplitTicket: action.reprice.IsSplitTicket,
          IsRefundable: action.reprice.IsRefundable,
          FareType: action.FareType,
          NdcData: {
            NdcRepriceOffId: action.reprice.AirResponses[0]?.NdcRepriceOffId,
            NdcRepriceResId: action.reprice.AirResponses[0]?.NdcRepriceResId,
          },
        },
      };
    case SET_REPRICED_AIR_ERROR:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          ErrorMessage: action.reprice.ErrorMessage,
        },
      };
    case UPDATE_SELECTED_AWARD:
      return {
        ...state,
        tripResults: {
          ...state.tripResults,
          SelectedAward: action.awardName,
        },
      };
    case FRONTIER_FLIGHT_REIMBURSMENT_UPDATE:
      return {
        ...state,
        travelCart: {
          ...state.travelCart,
          FronierFlightReimbursmentUpdate: {
            ...state.travelCart.FronierFlightReimbursmentUpdate,
            HiddenRebookAddressLine1: action.address?.ccBillingAddressFrontier,
            HiddenRebookAddressLine2: action.address?.ccBillingAddressFrontier,
            HiddenRebookCity: action.address?.ccCityFrontier,
            HiddenRebookCountryCode: action.address?.ccCountryFrontier,
            HiddenRebookStateCode: action.address?.ccStateFrontier,
            HiddenRebookStateName: action.address?.ccStateFrontier,
            HiddenRebookZipCode: action.address?.ccZipCodeFrontier,
          },
        },
      };
    case HOMEPAGE_ONEWAY_UDID_DATA:
      return {
        ...state,
        homepageUDIDdata: action.data,
      };
    default:
      return state;
  }
};
